import { startTiming } from './utils';

export default function popstateListener() {
  window.addEventListener('popstate', function (e) {
    startTiming(e.target.location.pathname);
  });
}
